/**
 * component to render in Eligibility tab at How to Nominate page E50
 */
const EligibilityPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-250 p-4 font-public-sans"
      data-testid="eligibility-page-component"
    >
      <p>
        To be eligible for consideration, a company must fulfil the following
        criteria:
      </p>

      <ul className="mb-4 list-outside list-disc pl-8">
        <li>
          Be a home-grown, privately-held enterprise incorporated under
          Singapore&apos;s Companies Act;
        </li>
        <li>
          Be a holding company or a subsidiary, as defined in Section 5 of the
          Companies Act;
        </li>
        <li>Not be listed on any stock exchange prior to 30 June 2026*;</li>
        <li>
          Be at least 30 per cent owned by Singapore Citizens or Permanent
          Residents or is significantly controlled** by Singapore Citizens or
          Singapore Permanent Residents; and
        </li>
        <li>
          Possess audited financial records for three years of operation as a
          private limited company in Singapore, as at 31 December 2025***.
          Submission of the 2025 audited financial statements is mandatory if
          available. Alternatively, unaudited financial statements certified by
          management will be considered.
        </li>
      </ul>

      <p>Other Criteria</p>

      <ul className="mb-4 list-outside list-disc pl-8">
        <li>
          Non-profit organisations, societies, charities, and partnerships are
          not eligible for consideration in the E50 Awards list
        </li>
        <li>
          Government Linked Companies (GLCs) and their subsidiaries are not
          eligible for consideration in the E50 Awards list
        </li>
        <li>
          All subsidiaries of listed holding companies will not be eligible.
        </li>
        <li>
          If an unlisted holding company participates, all subsidiaries will not
          be eligible.
        </li>
        <li>
          If an unlisted holding company chooses not to participate, then all
          unlisted subsidiaries are eligible for consideration.
        </li>
        <li>
          Companies that have received the E50 Award 10 times are no longer
          eligible to participate.
        </li>
      </ul>

      <p>
        Participants are evaluated on quantitative and qualitative criteria.
        Quantitative criteria considered include key performance indicators such
        as operating profit before tax, turnover, profit growth and return on
        equity. Qualitative criteria include business model, management ideals
        and innovation, internationalisation, knowledge initiatives, market
        branding and presence, risk management and sustainability.
      </p>

      <p className="text-xs">
        *All participating companies are required to notify the organisers in
        the event that the company, its holding company or subsidiaries have
        successfully applied for a public listing and expects such a listing on
        or before 30 June 2026;.
      </p>

      <p className="text-xs">
        **A person is considered to have significant control over the company if
        they:
        <ul className="mb-4 list-outside list-decimal pl-8">
          <li>
            Have an interest in more than 30% of shares in the company, either
            directly or through other companies; OR
          </li>
          <li>
            Can appoint or remove most of the company&apos;s directors; OR
          </li>
          <li>
            Control more than 30% of the voting rights in company decisions; OR
          </li>
          <li>
            Can influence or direct the company&apos;s key business decisions
            and activities.
          </li>
        </ul>
      </p>

      <p className="text-xs">
        ***Participating companies are required to write to the Enterprise 50
        Secretariat to request for an extension of deadline for the submission
        of the audited financial records if they are unable to submit them by
        the closing date (30 June 2026). Should the submission deadline fall on
        a weekend, the entries must be submitted by the next working day.
        Extension is subject to the organisers’ approval.
      </p>
    </div>
  );
};

export default EligibilityPage;
